/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CurrentMonthCountEnrollmentScheduleDto } from '../../models/current-month-count-enrollment-schedule-dto';

export interface EnrollmentScheduleControllerFindByCurrentMonthTicketV1$Params {
  date: string;
  ticketId: string;
}

export function enrollmentScheduleControllerFindByCurrentMonthTicketV1(http: HttpClient, rootUrl: string, params: EnrollmentScheduleControllerFindByCurrentMonthTicketV1$Params, context?: HttpContext): Observable<StrictHttpResponse<CurrentMonthCountEnrollmentScheduleDto>> {
  const rb = new RequestBuilder(rootUrl, enrollmentScheduleControllerFindByCurrentMonthTicketV1.PATH, 'get');
  if (params) {
    rb.query('date', params.date, {});
    rb.query('ticketId', params.ticketId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CurrentMonthCountEnrollmentScheduleDto>;
    })
  );
}

enrollmentScheduleControllerFindByCurrentMonthTicketV1.PATH = '/api/v1/enrollment-schedule/month';
